import { Coordinate } from '../../types/Site';
import { searchAllSites } from '../../store/ForNeighborsApi';
import { logAnalyticsEvent } from '../../utils/logAnalyticsEvent';
import { useForNeighborsSitesFetch, ForNeighborsSitesFetchResult } from './useForNeighborsSitesFetch';

export type UseSiteSearchResult = ForNeighborsSitesFetchResult;

// query === '' means idle/not searching -- SiteMapPantriesContent only calls this with a
// non-empty query once it has entered its own sticky "search mode" (3+ confirmed characters).
export function useSiteSearch(
  query: string,
  near: Coordinate | null,
  isLoggedIn: boolean
): UseSiteSearchResult {
  return useForNeighborsSitesFetch(
    query !== '',
    // An empty query always clears (there's no "still valid, just paused" case for search --
    // unlike useSitesWithinRadius, which distinguishes paused-while-searching from no-center).
    false,
    // isLoggedIn mirrors searchAllSites' needsSession param -- neighbors can search without an
    // account, so this must not unconditionally require a session.
    () => searchAllSites({ query, near: near ?? undefined }, isLoggedIn),
    [query, near?.latitude, near?.longitude, isLoggedIn],
    (response) => {
      // Metadata only, no query text or other PII.
      logAnalyticsEvent('search_initiated', {
        query_length: query.length,
        result_count: (response.sites ?? []).length,
        has_user_location: near !== null,
      });
    }
  );
}
